<template>
	<div class="animated fadeIn">

		<b-row>
			<b-col sm="12">

				<b-card header="Track Materials" v-if="loading.projects || loading.assignedProjects || loading.expense">Loading, please wait...</b-card>
				<b-card header="Track Materials" v-else>

					<b-alert variant="info" show v-if="((this.currentSelection.project != 'Select Project') && (this.dbAssignedProjects.indexOf(this.currentSelection.project) < 0))">You must be assigned to this project (with an active bill rate) to edit this page</b-alert>

                    <div><b-button-toolbar>

                        <b-input-group>
							<b-form-select id="projectSelection" :plain="true" :options="projectSelectionOptions" v-model="currentSelection.project" v-on:change="projectChanged"></b-form-select>
						</b-input-group>

						<!--
                        <b-button-group class="mx-2">
							<b-button id="editButton" variant="secondary" v-on:click="editClicked">Edit</b-button>
						</b-button-group>
						-->

					</b-button-toolbar></div>
						
					<b-form-checkbox id="inactiveCheckbox" :plain="true" v-on:change="inactiveChanged"><small>Show Inactive Projects</small></b-form-checkbox>

                    <br><br>

                    <div v-if="currentSelection.project != 'Select Project'"><b-button-toolbar>
                        <b-input-group>
							<b-form-select id="trackSelection" :plain="true" :options="['Track Cost','Track Order']" v-model="currentSelection.track" v-on:change="trackChanged"></b-form-select>
						</b-input-group>
					</b-button-toolbar><br></div>
						
					<b-table v-if="currentSelection.project != 'Select Project'" hover="true" striped="true" bordered="true" small="true" responsive="md" :items="items" :fields="fields" current-page="1" per-page="500">
						
						<template slot="date" slot-scope="data">
								<b-form-input size="sm" type="date" v-model="data.item.date" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="name" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.name" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="unit_cost" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.cost" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="extended_cost" slot-scope="data">
							<div v-if="data.item.cost.toString().length != 0">
								{{(Number(data.item.cost)*Number(data.item.qty_ordered)).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</div>
						</template>
						<template slot="markup" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.markup" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="price" slot-scope="data">
							<div v-if="data.item.cost.toString().length != 0">
								{{(Number(data.item.cost)*Number(data.item.qty_ordered)*(1 + (Number(data.item.markup) / 100))).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</div>
						</template>

						<template slot="order_number" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.order_number" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="qty_ordered" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.qty_ordered" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="qty_delivered" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.qty_delivered" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>
						<template slot="expected_delivery_date" slot-scope="data">
								<b-form-input size="sm" type="date" v-model="data.item.expected_delivery_date" v-on:change="expenseChanged($event, data.index)"></b-form-input>
						</template>

						<template slot="more" slot-scope="row">
							<b-button variant="primary" size="sm" @click.stop="showDetailsClicked($event, row)" class="mr-2">
								{{ row.detailsShowing ? 'Hide' : 'Show'}} More Info
							</b-button>
						</template>
						<template slot="row-details" slot-scope="row">
							<b-form-textarea :rows="2" :max-rows="2" placeholder="More Info" v-model="row.item.more"></b-form-textarea>
						</template>

						<template v-if="currentSelection.track == 'Track Cost'" slot="bottom-row" slot-scope="data">
							<td>Total</td>
							<td></td>
							<td></td>
							<td></td>
							<td>{{calculateTotal('cost').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</td>
							<td></td>
							<td>{{calculateTotal('price').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</td>
							<td></td>
						</template>
						
					</b-table>

					<br>

					<b-alert id="alertMessage" v-bind:variant=this.alertMessage.variant v-bind:show=this.alertMessage.show>{{this.alertMessage.message}}</b-alert>

                    <b-button variant="primary" v-if="this.dbAssignedProjects.indexOf(this.currentSelection.project) >= 0" v-on:click="saveClicked">Save</b-button>
					<b-button variant="primary" v-else-if="currentSelection.project != 'Select Project'" disabled>Save</b-button>
                    <b-button variant="link" v-if="currentSelection.project != 'Select Project'" v-on:click="cancelClicked">Cancel</b-button>
					<br><br>

				</b-card>

			</b-col>
		</b-row>
		<!--TODO: this is only for debugging, remove when done-->
		<!--{{this.dbExpense}}-->
	</div>

</template>



<script>

//'Materials.vue' is copied from 'Expense.vue' and then adding order info (order number, qty ordered, qty delivered, expected delivery date)
//'Materials.vue' is a superset to 'Expense.vue'
//TODO: combine 'Materials.vue' and 'Expense.vue' to a generic file to reduce duplicated code

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import axios from 'axios'
import uuidv4 from 'uuid/v4'

export default {
	name: 'materials',

	data: () => {
		return {
			projectSelectionOptions: [
				//{value: '', text: ''}
				{value: 'Select Project', text: 'Select Project'}
			],

			dbExpense: [			//for selected project, from the db
				//{id: '', date: '', name: '', cost: '', markup: '', more: '', order_number: '', qty_ordered: '', qty_delivered: '', expected_delivery_date: ''}
			],

			dbProjects: [			//for currently signed in employee's company, from the db
				//{id: '', name: '', active: true}
			],

			dbAssignedProjects: [	//for currently signed in employee, from the db
				//'uuid_project1'
			],

			currentSelection: {
				project: 'Select Project',
				track: 'Track Cost'
			},

			currentUser: {
				cognitoUser: null,
				email: '',
				role: '',
				company: '',
				token: ''
			},

			items: [
				//{id: '', date: '', name: '', cost: '', markup: '', more: '', order_number: '', qty_ordered: '', qty_delivered: '', expected_delivery_date: ''}
			],

			fields: {		//default to costFields
				date: {label: 'Date<br>&nbsp;', thStyle: {width: '100px'}},
				name: {label: 'Item Name<br>&nbsp;', thStyle: {width: '270px'}},
				unit_cost: {label: 'Unit<br>Cost ($)', thStyle: {width: '100px'}},
				qty_ordered: {label: 'Qty<br>Ordered', thStyle: {width: '100px'}},
				extended_cost: {label: 'Extended<br>Cost ($)', thStyle: {width: '100px'}},
				markup: {label: 'Markup<br>(%)', thStyle: {width: '100px'}},
				price: {label: 'Extended<br>Price ($)', thStyle: {width: '100px'}},
				more: {label: 'More Info<br>&nbsp;', thStyle: {width: '100px'}}
			},

			costFields: {
				date: {label: 'Date<br>&nbsp;', thStyle: {width: '100px'}},
				name: {label: 'Item Name<br>&nbsp;', thStyle: {width: '270px'}},
				unit_cost: {label: 'Unit<br>Cost ($)', thStyle: {width: '100px'}},
				qty_ordered: {label: 'Qty<br>Ordered', thStyle: {width: '100px'}},
				extended_cost: {label: 'Extended<br>Cost ($)', thStyle: {width: '100px'}},
				markup: {label: 'Markup<br>(%)', thStyle: {width: '100px'}},
				price: {label: 'Extended<br>Price ($)', thStyle: {width: '100px'}},
				more: {label: 'More Info<br>&nbsp;', thStyle: {width: '100px'}}
			},

			orderFields: {
				date: {label: 'Date<br>&nbsp;', thStyle: {width: '80px'}},
				name: {label: 'Item Name<br>&nbsp;', thStyle: {width: '270px'}},
				order_number: {label: 'Order<br>Number', thStyle: {width: '80px'}},
				qty_ordered: {label: 'Qty<br>Ordered', thStyle: {width: '80px'}},
				qty_delivered: {label: 'Qty<br>Delivered', thStyle: {width: '80px'}},
				expected_delivery_date: {label: 'Expected<br>Delivery Date', thStyle: {width: '80px'}},
				more: {label: 'More Info<br>&nbsp;', thStyle: {width: '100px'}}
			},

			alertMessage: {
				show: false,
				variant: 'success',		//'success' or 'danger'
				message: ''
			},

			loading: {
				projects: true,
				assignedProjects: true,
				expense: false
			}

		}
	},

	mounted() {

		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentUser.cognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					vueInstance.currentUser.token = session.getIdToken().getJwtToken();
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}

						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "custom:company")
								vueInstance.currentUser.company = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.currentUser.role = result[i].getValue();
							else if (result[i].getName() == "email")
								vueInstance.currentUser.email = result[i].getValue();
						}

						axios.get('/materials-expense/projects', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								vueInstance.dbProjects = JSON.parse(JSON.stringify(response.data));
								vueInstance.convertDbProjectsToProjectSelectionOptions(false);
								vueInstance.loading.projects = false;

							})
							.catch(function (error) {
							});

						axios.get('/materials-expense/assigned-projects', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								vueInstance.dbAssignedProjects = JSON.parse(JSON.stringify(response.data));
								vueInstance.loading.assignedProjects = false;
							})
							.catch(function (error) {
							});

					});
				}

			});
		}

    },

	methods: {
        showDetailsClicked: function (event, row) {
			row.toggleDetails();
            event.target.blur();
        },

		projectChanged: function (event) {
			document.getElementById("projectSelection").blur();
			this.alertMessage.show = false;
			this.alertMessage.variant = 'success';
			this.alertMessage.message = '';

			this.currentSelection.project = event;		//TODO: this line is needed because somehow v-model doesn't work, need to find out why
			if (event == 'Select Project') {
				this.dbExpense = [];
				this.items = [];
			}
			else {
				var vueInstance = this;
				vueInstance.loading.expense = true;
				axios.get('/materials-expense/expense', {params:{token:vueInstance.currentUser.token, project:event, materials:true}})
					.then(function (response) {
						vueInstance.dbExpense = JSON.parse(JSON.stringify(response.data));
						vueInstance.items = JSON.parse(JSON.stringify(response.data));

						//add empty rows at the end so there are at least 5 total rows and 1 empty row
						var itemLength = vueInstance.items.length;
						for (var i = 0; i < ((itemLength >= 5) ? 1 : (5 - itemLength)); i++)
							vueInstance.items.push({id: '', date: '', name: '', cost: '', markup: '', more: '', order_number: '', qty_ordered: '', qty_delivered: '', expected_delivery_date: ''});

						vueInstance.loading.expense = false;
					})
					.catch(function (error) {
					});
			}

		},

		trackChanged: function (event) {
			document.getElementById("trackSelection").blur();
			if (event == 'Track Cost') {
				this.fields = JSON.parse(JSON.stringify(this.costFields))
			}
			else {
				this.fields = JSON.parse(JSON.stringify(this.orderFields))
			}

		},

        inactiveChanged: function (event) {
            document.getElementById("inactiveCheckbox").blur();
			this.convertDbProjectsToProjectSelectionOptions(event);
		},
		
		expenseChanged: function (event, index) {
			//add empty row if user uses the last row
			if (index == (this.items.length - 1))
				this.items.push({id: '', date: '', name: '', cost: '', markup: '', more: '', order_number: '', qty_ordered: '', qty_delivered: '', expected_delivery_date: ''});
		},

        cancelClicked: function (event) {
            event.target.blur();
			this.alertMessage.show = false;
			this.alertMessage.variant = 'success';
			this.alertMessage.message = '';

			this.items = JSON.parse(JSON.stringify(this.dbExpense));

			//add empty rows at the end so there are at least 5 total rows and 1 empty row
			var itemLength = this.items.length;
			for (var i = 0; i < ((itemLength >= 5) ? 1 : (5 - itemLength)); i++)
				this.items.push({id: '', date: '', name: '', cost: '', markup: '', more: '', order_number: '', qty_ordered: '', qty_delivered: '', expected_delivery_date: ''});

        },

        saveClicked: function (event) {
			event.target.blur();
			
			var validated = true;
			var validateMessage = '';
			var itemsToBeSaved = [];
			var expenseToBeDeleted = [];	//array of string (expense id)

			//add to itemsToBeSaved and expenseToBeDeleted, exclude empty rows
			for (var i = 0; i < this.items.length; i++) {
				if (this.items[i].name.toString() != '') {
					itemsToBeSaved.push(JSON.parse(JSON.stringify(this.items[i])))
				}
				else if (this.items[i].id != '')
					expenseToBeDeleted.push(this.items[i].id)
			}

			//validate numbers
			for (i = 0; i < itemsToBeSaved.length; i++) {
				if (isNaN(itemsToBeSaved[i].cost) || isNaN(itemsToBeSaved[i].markup)) {
					validated = false;
					validateMessage = 'Invalid input (cost and markup must be numbers)'
					break;
				}
				if (isNaN(itemsToBeSaved[i].qty_ordered) || isNaN(itemsToBeSaved[i].qty_delivered)) {
					validated = false;
					validateMessage = 'Invalid input (qty must be numbers)'
					break;
				}
			}
			if (!validated) {
				this.alertMessage.message = validateMessage;
				this.alertMessage.variant = 'danger';
				this.alertMessage.show = true;
			}
			else {
				//validate name
				for (i = 0; i < itemsToBeSaved.length; i++) {
					if (itemsToBeSaved[i].name == '') {
						validated = false;
						break;
					}
				}
				if (!validated) {
					this.alertMessage.message = 'Invalid input (item name cannot be empty)';
					this.alertMessage.variant = 'danger';
					this.alertMessage.show = true;
				}
				else {
					//validate dates
					for (i = 0; i < itemsToBeSaved.length; i++) {
						if (!this.validateDateString(itemsToBeSaved[i].date)) {
							validated = false;
							validateMessage = 'Invalid input (date must be a valid date)';
							break;
						}
						if ((!this.validateDateString(itemsToBeSaved[i].expected_delivery_date)) && (itemsToBeSaved[i].expected_delivery_date != '')) {
							validated = false;
							validateMessage = 'Invalid input (expected delivery date must be a valid date)';
							break;
						}
					}
					if (!validated) {
						this.alertMessage.message = validateMessage;
						this.alertMessage.variant = 'danger';
						this.alertMessage.show = true;
					}
					else {

						//input validated, start saving

						event.target.disabled = true;
						this.alertMessage.show = false;
						this.alertMessage.variant = 'success';
						this.alertMessage.message = '';

						var expenseToBeAdded = [];
						var expenseToBeEdited = [];

						var vueInstance = this;

						//convert itemsToBeSaved cost and markup from string to number
						//comment out and do this on the server side instead
						/*
						for (i = 0; i < itemsToBeSaved.length; i++) {
							itemsToBeSaved[i].cost = Number(itemsToBeSaved[i].cost)
							itemsToBeSaved[i].markup = Number(itemsToBeSaved[i].markup)
						}
						*/

						//copy itemsToBeSaved to expenseToBeAdded / expenseToBeEdited for changed expense
						for (i = 0; i < itemsToBeSaved.length; i++) {
							for (var j = 0; j < this.dbExpense.length; j++) {
								if (itemsToBeSaved[i].id == this.dbExpense[j].id) {
									if (JSON.stringify(itemsToBeSaved[i]) != JSON.stringify(this.dbExpense[j])) {
										expenseToBeEdited.push(JSON.parse(JSON.stringify(itemsToBeSaved[i])))
									}
									break;
								}
							}
							if (j == this.dbExpense.length) {	//item not found in dbExpense
								itemsToBeSaved[i].id = uuidv4()
								expenseToBeAdded.push(JSON.parse(JSON.stringify(itemsToBeSaved[i])))
							}
						}

						axios.put('/materials-expense/expense', {token:vueInstance.currentUser.token, project:vueInstance.currentSelection.project, materials:true, expenseToBeAdded:expenseToBeAdded, expenseToBeEdited:expenseToBeEdited, expenseToBeDeleted:expenseToBeDeleted})
							.then(function (response) {
								vueInstance.dbExpense = JSON.parse(JSON.stringify(itemsToBeSaved));
								vueInstance.items = JSON.parse(JSON.stringify(itemsToBeSaved));

								//add empty rows at the end so there are at least 5 total rows and 1 empty row
								var itemLength = vueInstance.items.length;
								for (var i = 0; i < ((itemLength >= 5) ? 1 : (5 - itemLength)); i++)
									vueInstance.items.push({id: '', date: '', name: '', cost: '', markup: '', more: '', order_number: '', qty_ordered: '', qty_delivered: '', expected_delivery_date: ''});

								//get project name
								var projectName = '';
								for (i = 0; i < vueInstance.projectSelectionOptions.length; i++) {
									if (vueInstance.projectSelectionOptions[i].value == vueInstance.currentSelection.project) {
										projectName = vueInstance.projectSelectionOptions[i].text
										break;
									}
								}

								vueInstance.alertMessage.message = 'Materials for Project "' + projectName + '" saved successfully.';
								vueInstance.alertMessage.variant = 'success';
								vueInstance.alertMessage.show = true;
								event.target.disabled = false;
							})
							.catch(function (error) {
								vueInstance.alertMessage.message = 'Update failed. Please try again later.';
								vueInstance.alertMessage.variant = 'danger';
								vueInstance.alertMessage.show = true;
								event.target.disabled = false;
							});
					}
						
				}
			}
        },

		convertDbProjectsToProjectSelectionOptions (showInactive) {
			this.projectSelectionOptions = [];
			for (var i = 0; i < this.dbProjects.length; i++) {
				if ((this.dbProjects[i].active) || (showInactive)) {
					this.projectSelectionOptions.push({value:'',text:''});
					this.projectSelectionOptions[this.projectSelectionOptions.length - 1].value = this.dbProjects[i].id;
					this.projectSelectionOptions[this.projectSelectionOptions.length - 1].text = this.dbProjects[i].name;
				}
			}
			this.projectSelectionOptions.unshift({value:'Select Project',text:'Select Project'});
		},

		calculateTotal (column) {
			var total = 0;
			if (column == 'cost') {
				for (var i = 0; i < this.items.length; i++) {
					total += (Number(this.items[i].cost) * Number(this.items[i].qty_ordered))
				}
			}
			else if (column == 'price') {
				for (var i = 0; i < this.items.length; i++) {
					total += (Number(this.items[i].cost) * Number(this.items[i].qty_ordered) * (1 + (Number(this.items[i].markup) / 100)))
				}
			}
			return total;
		},

		validateDateString (dateString) {
			if (dateString.length != 10)
				return false;
			var ymd = dateString.split('-');
			if ((ymd[0].length != 4) || (ymd[1].length != 2) || (ymd[2].length != 2))
				return false;
			if (!((/^\d+$/.test(ymd[0])) && (/^\d+$/.test(ymd[1])) && (/^\d+$/.test(ymd[2]))))
				return false;
			var y = Number(ymd[0]);
			var m = Number(ymd[1]);
			var d = Number(ymd[2]);
			if ((y < 1900) || (y > 2100) || (m < 1) || (m > 12) || (d < 1) || (d > 31))
				return false;
			return true;
		}

	}


}
</script>



<style>

input[type=date]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}

</style>
